import { gql } from "@apollo/client";

export const SEARCH_BREEDS = gql`
  query searchBreeds($data: SearchBreedsInput!) {
    searchBreeds(
      data: $data
    ) {
      breeds {
        id,
        active,
        name,
        species_id
      },
      messages,
      success,
    }
  }
`;
